export default __webpack_public_path__ + "static/media/iot-item-24px.bfa5b419.svg";